<template>
	<div>
		<page-title-bar></page-title-bar>
		<v-container fluid grid-list-xl pt-0>
			<v-layout row wrap>
				<app-card :fullBlock="true" colClasses="xs12">
					<v-card-title>
						<v-spacer></v-spacer>

						<v-text-field
							append-icon="search"
							hide-details
							:label="$t('message.search')"
							single-line
							v-model="search"
						></v-text-field>
					</v-card-title>

					<v-data-table
						:headers="headers"
						:items="dealerShippings"
						:search="search"
						:pagination.sync="pagination"
					>
						<template slot="headerCell" slot-scope="props">
							<v-tooltip bottom>
								<span slot="activator">{{
									$t(`message.${props.header.text}`)
								}}</span>
								<span>{{ $t(`message.${props.header.text}`) }}</span>
							</v-tooltip>
						</template>
						<template slot="items" slot-scope="props">
							<td>{{ props.item.bill_id }}</td>
							<td>
								<a :href="`/dealer-details/${props.item.id}`">{{
									props.item.fullName
								}}</a>
							</td>
							<td class="text-center">
								<v-chip
									outline
									color="light-green accent-4"
									v-if="props.item.own_delivery"
									>{{ $t("message.yes") }}</v-chip
								>

								<v-chip color="red" outline v-else>{{
									$t("message.no")
								}}</v-chip>
							</td>
							<td class="text-center">{{ props.item.identification }}</td>
							<td>{{ props.item.created_at }}</td>

							<td class="text-center">
								<v-chip
									outline
									color="light-green accent-4"
									v-if="props.item.pay === paymentStatus.PAID"
									>{{ $t("message.paid") }}</v-chip
								>

								<v-chip color="red" outline v-else>{{
									$t("message.notPaid")
								}}</v-chip>
							</td>
							<td>
								<v-tooltip top v-if="props.item.pay !== paymentStatus.PAID">
									<v-btn
										color="success"
										:loading="onLoading"
										outline
										fab
										icon
										small
										slot="activator"
										@click="onPay(props.item)"
									>
										<v-icon light>check</v-icon>
									</v-btn>
									<span>{{ $t("message.markAsPaid") }}</span>
								</v-tooltip>
								<v-tooltip top v-else>
									<v-btn
										color="error"
										:loading="onLoading"
										outline
										fab
										icon
										small
										slot="activator"
										@click="onPay(props.item)"
									>
										<v-icon light>close</v-icon>
									</v-btn>
									<span>{{ $t("message.markAsNotPaid") }}</span>
								</v-tooltip>
							</td>
						</template>
					</v-data-table>
				</app-card>
			</v-layout>
		</v-container>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { generateFullNameProp } from "../../../helpers/helpers";
import { purchaseStatus, paymentStatus } from "../../../constants/constants";
import {
	GET_SHIPPINGS,
	MARK_DELIVERY_AS_PAID,
} from "../../../store/modules/delivery/store/actions.type";

export default {
	name: "shippingsList",
	data() {
		return {
			paymentStatus: {
				NOT_PAID: 0,
				PAID: 1,
			},
			headers: [
				{ text: "id", sortable: true, value: "bill_id" },
				{ text: "dealerName", sortable: false, value: "fullName" },
				{
					text: "ownDelivery",
					align: "center",
					sortable: true,
					value: "own_delivery",
				},
				{
					text: "dealerId",
					align: "center",
					sortable: false,
					value: "identification",
				},
				{ text: "lastUpdate", sortable: true, value: "created_at" },
				{ text: "status", align: "center", sortable: true, value: "pay" },
				{ text: "actions", sortable: false, value: "" },
			],
			selectedDealer: {},
			dealerShippings: [],
			pagination: {},
			search: "",
			pagination: {
				descending: true,
				sortBy: "created_at",
				rowsPerPage: 10,
			},
			onLoading: false,
		};
	},
	computed: {
		...mapGetters(["shippings"]),
	},
	created() {
		this.getShippings();
	},
	methods: {
		getShippings() {
			this.$store.dispatch(GET_SHIPPINGS).then(() => {
				generateFullNameProp(this.shippings);
				this.dealerShippings = [...this.shippings];
			});
		},
		async onPay(item) {
			this.onLoading = true;

			await this.$store
				.dispatch(MARK_DELIVERY_AS_PAID, item)
				.then(async (res) => {
					await this.getShippings();
					this.onLoading = false;
				})
				.catch((err) => {
					this.onLoading = false;
					//console.log(err)
				});
		},
		formatIdentification(identification) {
			return Number(identification).toLocaleString();
		},
		handleRedirect({ id }) {
			this.$router.push(`/dealer-details/${id}`);
		},
	},
};
</script>

<style></style>
